import { render, staticRenderFns } from "./BannedItem.vue?vue&type=template&id=aebe309e&scoped=true"
import script from "./BannedItem.vue?vue&type=script&lang=js"
export * from "./BannedItem.vue?vue&type=script&lang=js"
import style0 from "./BannedItem.vue?vue&type=style&index=0&id=aebe309e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebe309e",
  null
  
)

export default component.exports